import React from 'react';
import '../style/components-style/Tooltip.css';

const Tooltip = ({ message, children }) => {
    return (
        <div className="tooltip-container">
            {children}
            <div className="tooltip-message">
                {message}
            </div>
        </div>
    );
};

export default Tooltip;
